import Translatable from '../translatable_text/Translatable';
import { teamData } from '@/l-data/team';
function Team() {
  

  return (
    <section style={{ paddingTop: '5rem'}} className="team section-paddingx d-rotate wow">
      <div className="max-w-7xl mx-auto px-4">
        <div className="sec-head mb-80">
          <h2 className="sub-title main-color mb-25">
            <Translatable>
              Our Team
            </Translatable>
          </h2>
          <div className="bord pt-25 bord-thin-top flex items-center justify-between">
              <h2 className="ltr:hidden fw-600 text-4xl d-rotate wow">
                <span className="rotate-text">
                  تعرف على <span className="fw-200">فريقنا</span>
                </span>
              </h2>
              <h2 className="rtl:hidden fw-600 text-5xl d-rotate wow">
                <span className="rotate-text">
                  Meet our <span className="fw-200">team</span></span>
              </h2>
            <div className='flex items-center justify-center'>
              <a href="/join-the-team" aria-label='go to join' className="go-more flex items-center gap-3">
                <span className="text underline">
                  <Translatable>
                    Join to us
                  </Translatable>
                </span>
                <img 
                  src="/light/assets/imgs/arrow-right.webp"
                  alt="icon"
                  loading='lazy'
                  className="icon-img-20 ml-5 -mr-1"
                  width="40px"
                  height="40px"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap">
          {teamData.map((item, i) => (
            <div key={i} className="w-full lg:w-1/3 md:w-1/2 pt-4 rotate-text">
             <div className="item md-mb50">
               <div className="img">
                 <img src={item.img} alt="" loading="lazy" decoding="async" />
                 <div className="info">
                   <span className="fz-12">{item.subName}</span>
                   <h6 className="fz-18">{item.name}</h6>
                 </div>
               </div>
               <div className="social">
                 <div className="links">
                   <a href={item.socials.linkedin} aria-label='social link button'>
                     <i className="fab fa-linkedin"></i>
                   </a>
                   <a href={item.socials.Twitter} aria-label='social link button'>
                     <i className="fab fa-twitter"></i>
                   </a>
                 </div>
               </div>
             </div>
           </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
